import { Controller } from "@hotwired/stimulus"

// Mirrors Helm's per-Trip-Type Field Configurations. The visibility map is
// fetched live from Helm (`/api/v1/jobs/GetTripTypeConfiguration`) and
// passed down as a data attribute — shaped like
//   { "<trip_type_id>": { "IsRequestedDateFirm": true, "Duration": false } }
// Each field element carries its Helm field name on `data-field-name`. When
// no entry exists for a trip type (or no entry exists for a specific field),
// the field stays visible — matches Helm's "no override ⇒ default visible".
export default class extends Controller {
  static targets = ["select", "field"]
  static values = { visibility: Object }

  connect() { this.apply() }

  apply() {
    const tripTypeId = this.selectTarget.value
    const fieldMap = this.visibilityValue?.[tripTypeId] || {}
    this.fieldTargets.forEach((el) => {
      const fieldName = el.dataset.fieldName
      const visible = fieldName in fieldMap ? fieldMap[fieldName] : true
      this.toggle(el, visible)
    })
  }

  toggle(el, visible) {
    if (!el) return
    el.hidden = !visible
    if (!visible) {
      el.querySelectorAll("input, select, textarea").forEach((input) => {
        if (input.type === "checkbox") input.checked = false
        else input.value = ""
      })
    }
  }
}
